import logo from './acmeai.svg';
import './App.css';
import React, { useEffect, useState } from 'react';
import ImageIcon from '@material-ui/icons/Image';
import Button from '@material-ui/core/Button';
import Removed from './components/Removed/Removed';

function App() {
  const [image, setImage] = useState('');
  const [imgPath, setImgPath] = useState('');
  const [removed, setRemoved] = useState('https://i.ytimg.com/vi/16X0oEr4V3k/maxresdefault.jpg')
  const [click, setClick] = useState(false)
  const handleRemove = () => {
    console.log(removed)
    fetch('https://acme-removebg.herokuapp.com/upload', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        imageUrl: image,
      })
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setImgPath(data);
        setRemoved(`https://acme-removebg.herokuapp.com/bgremoved.png`)
        console.log(removed)
      })
    setClick(true)
  }

  return (
    <div className="container mb-5">
      <img className="acme-logo" src={logo} alt=""/>
      <h1 className="text-center">Acme AI Image Background Remover</h1>
      <div className="text-center admin-form">
        <input className="url-input" placeholder="Please input image url" type="text" onChange={(event) => setImage(event.target.value)} />
        <br/>
        <Button
          variant="contained"
          color="primary"
          onClick= {handleRemove}
          startIcon={<ImageIcon />}
        >
          Remove
      </Button>
      </div>
      <div className="container">
        <div class="row">
          <div class="col-sm">
            <div className="image">
              {image ? <img src={image} alt="removed"/> : <img src='https://ichef.bbci.co.uk/images/ic/1200x675/p07y9mzq.jpg' />}
            </div>
          </div>
          <div class="col-sm">
          <div className="image border">
              {click ? <Removed removed={removed}></Removed> : <img src={removed} />}
            </div>
          </div>
        </div>
      </div>


    </div>
  );
}

export default App;
